<template>
  <div class="boy_warphry">
    <div class="rkcz">
      <div>常住人口</div>
      <div class="twos">
        <div class="one">
          <span>{{ datas.czrk }}</span
          ><span>(人)</span>
          <div>常住人口</div>
        </div>
        <div class="one aa">
          <span>{{ datas.czrknan }}</span
          ><span>(人)</span>
          <div>男性人数</div>
        </div>
        <div class="one bb">
          <span>{{ datas.czrknv }}</span
          ><span>(人)</span>
          <div>女性人口</div>
        </div>
      </div>
    </div>
    <!-- <el-card> -->
    <div class="npm">
      <p>分地区性别的常住人口</p>
      <div ref="echartsINof" class="echarts" style="height: 40vh"></div>
    </div>
    <!-- </el-card> -->
  </div>
</template>

<script>
import { tj } from "@/network";
export default {
  data() {
    return {
      datas: {},
      name: "男",
    };
  },
  created() {},
  mounted() {
    this.getInfoDatas();
    this.getname();
    this.getInfoData();
    // this.handEchart();
  },
  methods: {
    getname() {
      let myechart = this.$echarts.init(this.$refs.echartsINof);
      myechart.on("legendselectchanged", (params) => {
        // console.log(params.name);
        this.name = params.name;
        this.getInfoData();
      });
    },
    async getInfoDatas() {
      const { code, data, msg } = await tj({
        tableName: "jxq_fdqxbczrk",
        isOutside: 0,
      });
      this.datas = data[0];
      // console.log(data[0], 123);
    },
    async getInfoData() {
      const { code, data, msg } = await tj({
        tableName: "jxq_fdqxbczrk",
        streetCode: "110105011",
        isOutside: 0,
      });
      var compare = function (attribute) {
        return function (obj1, obj2) {
          var val1 = obj1[attribute];
          var val2 = obj2[attribute];
          // if (val1 < val2) {
          //   return 1;
          // } else if (val1 > val2) {
          //   return -1;
          // } else {
          //   return 0;
          // }
        };
      };
      if (this.name == "男") {
        let datas = data.sort(compare("czrknan")); //通过Id排序完成后的数组
      } else {
        let datas = data.sort(compare("czrknv")); //通过Id排序完成后的数组
      }
      // console.log(data);
      let czrk = []; //常住人口
      let villages_name = []; //社区名称
      let czrknan = []; //常住外来人口
      let czrknv = []; //常住外来人口
      for (const item of data) {
        czrk.push(item.czrk);
        villages_name.push(item.villages_name);
        czrknan.push(item.czrknan);
        czrknv.push(item.czrknv);
      }
      this.handEchart(czrk, villages_name, czrknan, czrknv);
    },
    handEchart(e, es, ese, ee) {
      let myechart = this.$echarts.init(this.$refs.echartsINof);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          selectedMode: "single", //取消图例的点击事件
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },

        yAxis: {
          type: "category",
          data: es,
          textStyle: {
            color: "#fff",
          },
        },
        // styleColor:"#fff",
        textStyle: {
          color: "#fff",
        },
        series: [
          {
            name: "男",
            color: "#00BFFF",
            type: "bar",
            data: ese,
          },
          {
            name: "女",
            color: "	#7CFC00",
            type: "bar",
            data: ee,
          },
        ],
      };
      myechart.setOption(option);
    },
  },
};
</script>

<style scoped lang="less">
.boy_warphry {
  background-color: rgba(20, 48, 99, 0);
  .npm {
    p {
      color: #fff;
      text-align: center;
      font-size: 18px;
      padding: 2vh;
    }
    .echarts {
      margin: 1vw;
    }
  }
}
.rkcz {
  div {
    color: #fff;
    text-align: center;
    margin-top: 2vh;
    font-size: 18px;
    margin-bottom: 2vh;
  }
  .twos {
    border: 1px solid #21517d;
    margin: 0 2vw;
    margin-bottom: 0.8vw;
    .one {
      display: inline-block;
      font-size: 18px;
      color: #fffd7d;
      padding-top: 1vh;
      span:nth-child(2) {
        font-size: 12px;
      }
      div {
        font-size: 12px;
        color: #fff;
        margin-top: 5px;
      }
    }
    .aa {
      border-top: 0;
      border-bottom: 0;
      padding: 0 2.5vw;
    }
  }
}
</style>
